import * as React from "react";
const SvgEmptyIncidents = (props) => /* @__PURE__ */ React.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 375 375", style: {
  fillRule: "evenodd",
  clipRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 1.5
}, ...props }, /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1.00267,0,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 375, height: 374, style: {
  fillOpacity: 0
} })), /* @__PURE__ */ React.createElement("circle", { cx: 187.5, cy: 187.5, r: 86.5, style: {
  fill: "rgb(40,36,36)",
  fillOpacity: 0,
  stroke: "rgb(40,36,36)",
  strokeWidth: 2
} }), /* @__PURE__ */ React.createElement("g", { transform: "matrix(0.895954,0,0,0.895954,19.5087,19.5087)" }, /* @__PURE__ */ React.createElement("path", { d: "M274,187.5C274,235.241 235.241,274 187.5,274", style: {
  fill: "rgb(40,36,36)",
  fillOpacity: 0,
  stroke: "rgb(40,36,36)",
  strokeWidth: "2.23px"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,-10,-18)" }, /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,20,10)" }, /* @__PURE__ */ React.createElement("path", { d: "M22,49C22,44.033 26.033,40 31,40C32.879,40 34.624,40.577 36.068,41.563C36.792,33.958 43.206,28 51,28C58.794,28 65.208,33.958 65.932,41.563C67.376,40.577 69.121,40 71,40C75.967,40 80,44.033 80,49M22,49L10,49M80,49L92,49", style: {
  fill: "rgb(40,36,36)",
  fillOpacity: 0,
  stroke: "rgb(40,36,36)",
  strokeWidth: 2
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,18,10)" }, /* @__PURE__ */ React.createElement("path", { d: "M45,40C45,36.689 47.689,34 51,34", style: {
  fill: "rgb(40,36,36)",
  fillOpacity: 0,
  stroke: "rgb(40,36,36)",
  strokeWidth: 2
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,-22.2865,126.812)" }, /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,20,10)" }, /* @__PURE__ */ React.createElement("path", { d: "M22,49C22,44.033 26.033,40 31,40C32.879,40 34.624,40.577 36.068,41.563C36.792,33.958 43.206,28 51,28C58.794,28 65.208,33.958 65.932,41.563C67.376,40.577 69.121,40 71,40C75.967,40 80,44.033 80,49M22,49L10,49M80,49L92,49", style: {
  fill: "rgb(40,36,36)",
  fillOpacity: 0,
  stroke: "rgb(40,36,36)",
  strokeWidth: 2
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,18,10)" }, /* @__PURE__ */ React.createElement("path", { d: "M45,40C45,36.689 47.689,34 51,34", style: {
  fill: "rgb(40,36,36)",
  fillOpacity: 0,
  stroke: "rgb(40,36,36)",
  strokeWidth: 2
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,243,40)" }, /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,20,10)" }, /* @__PURE__ */ React.createElement("path", { d: "M22,49C22,44.033 26.033,40 31,40C32.879,40 34.624,40.577 36.068,41.563C36.792,33.958 43.206,28 51,28C58.794,28 65.208,33.958 65.932,41.563C67.376,40.577 69.121,40 71,40C75.967,40 80,44.033 80,49M22,49L10,49M80,49L92,49", style: {
  fill: "rgb(40,36,36)",
  fillOpacity: 0,
  stroke: "rgb(40,36,36)",
  strokeWidth: 2
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,18,10)" }, /* @__PURE__ */ React.createElement("path", { d: "M45,40C45,36.689 47.689,34 51,34", style: {
  fill: "rgb(40,36,36)",
  fillOpacity: 0,
  stroke: "rgb(40,36,36)",
  strokeWidth: 2
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,32)" }, /* @__PURE__ */ React.createElement("path", { d: "M160,312.991L160,337.458C160,339.965 162.035,342 164.542,342L210.458,342C212.965,342 215,339.965 215,337.458L215,313.017", style: {
  fill: "rgb(40,36,36)",
  fillOpacity: 0,
  stroke: "rgb(40,36,36)",
  strokeWidth: 2
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,32)" }, /* @__PURE__ */ React.createElement("path", { d: "M215,307.007L215,300.542C215,298.035 212.965,296 210.458,296L164.542,296C162.035,296 160,298.035 160,300.542L160,306.969", style: {
  fill: "rgb(40,36,36)",
  fillOpacity: 0,
  stroke: "rgb(40,36,36)",
  strokeWidth: 2
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,2)" }, /* @__PURE__ */ React.createElement("path", { d: "M225,338.5C225,337.672 224.328,337 223.5,337L151.5,337C150.672,337 150,337.672 150,338.5L150,341.5C150,342.328 150.672,343 151.5,343L223.5,343C224.328,343 225,342.328 225,341.5L225,338.5Z", style: {
  fill: "rgb(40,36,36)",
  fillOpacity: 0,
  stroke: "rgb(40,36,36)",
  strokeWidth: 2
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,3.63158,0,-528.947)" }, /* @__PURE__ */ React.createElement("path", { d: "M225,239L252,213.391", style: {
  fill: "none",
  stroke: "rgb(40,36,36)",
  strokeWidth: "0.75px"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,3.63158,0,-528.947)" }, /* @__PURE__ */ React.createElement("path", { d: "M123,213.391L150,239", style: {
  fill: "none",
  stroke: "rgb(40,36,36)",
  strokeWidth: "0.75px"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(0.707107,0.707107,-0.707107,0.707107,203.465,-76.6044)" }, /* @__PURE__ */ React.createElement("path", { d: "M180.951,141.443C186.507,136.9 196.536,140.03 197.435,147.86C197.493,148.365 197.486,148.493 197.5,149L197.5,223C197.447,224.851 197.272,225.366 196.922,226.349C195.653,229.919 192.225,232.611 188.407,232.959C187.903,233.005 187.776,232.995 187.27,232.997L143.77,231.997C141.435,231.877 140.677,231.544 139.383,230.87C133.385,227.748 132.333,217.913 138.31,213.777C140.034,212.584 142.138,212.014 144.23,212.003L177.5,212.767L177.5,149C177.5,149 178.201,143.967 180.951,141.443Z", style: {
  fill: "rgb(40,36,36)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("clipPath", { id: "_clip1" }, /* @__PURE__ */ React.createElement("path", { d: "M180.951,141.443C186.507,136.9 196.536,140.03 197.435,147.86C197.493,148.365 197.486,148.493 197.5,149L197.5,223C197.447,224.851 197.272,225.366 196.922,226.349C195.653,229.919 192.225,232.611 188.407,232.959C187.903,233.005 187.776,232.995 187.27,232.997L143.77,231.997C141.435,231.877 140.677,231.544 139.383,230.87C133.385,227.748 132.333,217.913 138.31,213.777C140.034,212.584 142.138,212.014 144.23,212.003L177.5,212.767L177.5,149C177.5,149 178.201,143.967 180.951,141.443Z" })), /* @__PURE__ */ React.createElement("g", { clipPath: "url(#_clip1)" }, /* @__PURE__ */ React.createElement("g", { transform: "matrix(0.633984,8.32667e-17,5.55112e-17,0.633984,111.135,100.711)" }, /* @__PURE__ */ React.createElement("g", { opacity: 0.5 }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,1.42109e-14,64)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,64,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,64,64)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,128)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,1.42109e-14,64)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,64,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,64,64)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,128,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,1.42109e-14,64)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,64,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,64,64)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,128,128)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,1.42109e-14,64)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,64,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,64,64)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,32,32)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,0)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,16,16)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,0)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,8,8)" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 8, height: 8, style: {
  fill: "rgb(124,213,0)",
  fillOpacity: 0
} }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 2, style: {
  fill: "white"
} }))))))))), /* @__PURE__ */ React.createElement("path", { d: "M180.951,141.443C186.507,136.9 196.536,140.03 197.435,147.86C197.493,148.365 197.486,148.493 197.5,149L197.5,223C197.447,224.851 197.272,225.366 196.922,226.349C195.653,229.919 192.225,232.611 188.407,232.959C187.903,233.005 187.776,232.995 187.27,232.997L143.77,231.997C141.435,231.877 140.677,231.544 139.383,230.87C133.385,227.748 132.333,217.913 138.31,213.777C140.034,212.584 142.138,212.014 144.23,212.003L177.5,212.767L177.5,149C177.5,149 178.201,143.967 180.951,141.443Z", style: {
  fill: "none",
  stroke: "rgb(40,36,36)",
  strokeWidth: 2,
  strokeLinecap: "butt",
  strokeMiterlimit: 2
} })), /* @__PURE__ */ React.createElement("path", { d: "M35,78C35,78 43.639,73.673 53.297,80.054C63.04,73.853 70.747,78.081 71,78", style: {
  fill: "rgb(40,36,36)",
  stroke: "rgb(40,36,36)",
  strokeWidth: 2
} }), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,222.238,-41.7422)" }, /* @__PURE__ */ React.createElement("path", { d: "M35,78C35,78 43.639,73.673 53.297,80.054C63.04,73.853 70.747,78.081 71,78", style: {
  fill: "rgb(40,36,36)",
  stroke: "rgb(40,36,36)",
  strokeWidth: 2
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,123.146,-20.2026)" }, /* @__PURE__ */ React.createElement("path", { d: "M35,78C35,78 43.639,73.673 53.297,80.054C63.04,73.853 70.747,78.081 71,78", style: {
  fill: "rgb(40,36,36)",
  stroke: "rgb(40,36,36)",
  strokeWidth: 2
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,276.254,131.773)" }, /* @__PURE__ */ React.createElement("path", { d: "M35,78C35,78 43.639,73.673 53.297,80.054C63.04,73.853 70.747,78.081 71,78", style: {
  fill: "rgb(40,36,36)",
  stroke: "rgb(40,36,36)",
  strokeWidth: 2
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(0.741815,0,0,0.555684,51.5098,161.618)" }, /* @__PURE__ */ React.createElement("path", { d: "M193.432,375L213.921,375C214.517,375 215,374.462 215,373.8L215,346.192", style: {
  fill: "rgb(40,36,36)",
  fillOpacity: 0,
  stroke: "rgb(40,36,36)",
  strokeWidth: "3.05px"
} })), /* @__PURE__ */ React.createElement("g", { id: "Star" }, /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,2,1,-127)" }, /* @__PURE__ */ React.createElement("path", { d: "M40,126L40,128", style: {
  fill: "none",
  stroke: "rgb(40,36,36)",
  strokeWidth: "1.26px"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(6.12323e-17,1,-2,1.22465e-16,295,87)" }, /* @__PURE__ */ React.createElement("path", { d: "M40,126L40,128", style: {
  fill: "none",
  stroke: "rgb(40,36,36)",
  strokeWidth: "1.26px"
} }))), /* @__PURE__ */ React.createElement("g", { id: "Star1", transform: "matrix(1,0,0,1,75,-38)" }, /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,2,1,-127)" }, /* @__PURE__ */ React.createElement("path", { d: "M40,126L40,128", style: {
  fill: "none",
  stroke: "rgb(40,36,36)",
  strokeWidth: "1.26px"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(6.12323e-17,1,-2,1.22465e-16,295,87)" }, /* @__PURE__ */ React.createElement("path", { d: "M40,126L40,128", style: {
  fill: "none",
  stroke: "rgb(40,36,36)",
  strokeWidth: "1.26px"
} }))), /* @__PURE__ */ React.createElement("g", { id: "Star2", transform: "matrix(1,0,0,1,282.116,150.113)" }, /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,2,1,-127)" }, /* @__PURE__ */ React.createElement("path", { d: "M40,126L40,128", style: {
  fill: "none",
  stroke: "rgb(40,36,36)",
  strokeWidth: "1.26px"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(6.12323e-17,1,-2,1.22465e-16,295,87)" }, /* @__PURE__ */ React.createElement("path", { d: "M40,126L40,128", style: {
  fill: "none",
  stroke: "rgb(40,36,36)",
  strokeWidth: "1.26px"
} }))), /* @__PURE__ */ React.createElement("g", { id: "Star3", transform: "matrix(1,0,0,1,47.7734,133.205)" }, /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,2,1,-127)" }, /* @__PURE__ */ React.createElement("path", { d: "M40,126L40,128", style: {
  fill: "none",
  stroke: "rgb(40,36,36)",
  strokeWidth: "1.26px"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(6.12323e-17,1,-2,1.22465e-16,295,87)" }, /* @__PURE__ */ React.createElement("path", { d: "M40,126L40,128", style: {
  fill: "none",
  stroke: "rgb(40,36,36)",
  strokeWidth: "1.26px"
} }))), /* @__PURE__ */ React.createElement("g", { id: "Star4", transform: "matrix(1,0,0,1,168.207,-105.179)" }, /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,2,1,-127)" }, /* @__PURE__ */ React.createElement("path", { d: "M40,126L40,128", style: {
  fill: "none",
  stroke: "rgb(40,36,36)",
  strokeWidth: "1.26px"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(6.12323e-17,1,-2,1.22465e-16,295,87)" }, /* @__PURE__ */ React.createElement("path", { d: "M40,126L40,128", style: {
  fill: "none",
  stroke: "rgb(40,36,36)",
  strokeWidth: "1.26px"
} }))), /* @__PURE__ */ React.createElement("g", { id: "Star5", transform: "matrix(1,0,0,1,216.238,-70.1398)" }, /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,2,1,-127)" }, /* @__PURE__ */ React.createElement("path", { d: "M40,126L40,128", style: {
  fill: "none",
  stroke: "rgb(40,36,36)",
  strokeWidth: "1.26px"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(6.12323e-17,1,-2,1.22465e-16,295,87)" }, /* @__PURE__ */ React.createElement("path", { d: "M40,126L40,128", style: {
  fill: "none",
  stroke: "rgb(40,36,36)",
  strokeWidth: "1.26px"
} }))), /* @__PURE__ */ React.createElement("g", { id: "Star6", transform: "matrix(1,0,0,1,-21.1927,104.287)" }, /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,2,1,-127)" }, /* @__PURE__ */ React.createElement("path", { d: "M40,126L40,128", style: {
  fill: "none",
  stroke: "rgb(40,36,36)",
  strokeWidth: "1.26px"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(6.12323e-17,1,-2,1.22465e-16,295,87)" }, /* @__PURE__ */ React.createElement("path", { d: "M40,126L40,128", style: {
  fill: "none",
  stroke: "rgb(40,36,36)",
  strokeWidth: "1.26px"
} }))), /* @__PURE__ */ React.createElement("g", { id: "Star7", transform: "matrix(1,0,0,1,311.608,-74.0711)" }, /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,2,1,-127)" }, /* @__PURE__ */ React.createElement("path", { d: "M40,126L40,128", style: {
  fill: "none",
  stroke: "rgb(40,36,36)",
  strokeWidth: "1.26px"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(6.12323e-17,1,-2,1.22465e-16,295,87)" }, /* @__PURE__ */ React.createElement("path", { d: "M40,126L40,128", style: {
  fill: "none",
  stroke: "rgb(40,36,36)",
  strokeWidth: "1.26px"
} }))), /* @__PURE__ */ React.createElement("g", { id: "Star8", transform: "matrix(1,0,0,1,274.195,39.2461)" }, /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,2,1,-127)" }, /* @__PURE__ */ React.createElement("path", { d: "M40,126L40,128", style: {
  fill: "none",
  stroke: "rgb(40,36,36)",
  strokeWidth: "1.26px"
} })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(6.12323e-17,1,-2,1.22465e-16,295,87)" }, /* @__PURE__ */ React.createElement("path", { d: "M40,126L40,128", style: {
  fill: "none",
  stroke: "rgb(40,36,36)",
  strokeWidth: "1.26px"
} }))));
export default SvgEmptyIncidents;
